import { KPI as KPIModel } from '../model';
import { AbstractBCMPortal } from './abstractBCMPortal';

export class KPI extends AbstractBCMPortal {
  endpoint = '/overview';
  model = new KPIModel();
  withParams = true;
}
